import React from 'react';
import Spinner from 'react-spinner-children';

const green = '#287433';

const Loader = props => {
  const spinConfig = {
    color: props.color || green,
    scale: props.scale || 1
  };

  return <Spinner loaded={!props.isRequestOut} config={spinConfig}></Spinner>;
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/shared/Spinner.js